import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/services/api/client'

export interface PendingResolutionCount {
  /** Entities (members) sitting in a hidden review group awaiting resolution. */
  candidates: number
  /** Distinct review groups those candidates belong to. */
  groups: number
}

/** Lightweight count of entities awaiting resolution — drives the nav-rail badge
 * that nudges the analyst to unify entities instead of skipping ER. */
export function usePendingResolutionCount(caseId: string | undefined) {
  return useQuery({
    queryKey: ['case', caseId, 'entity-resolution', 'groups', 'pending-count'],
    queryFn: () =>
      apiClient.get<PendingResolutionCount>(
        `/v1/cases/${caseId}/entity-resolution/groups/pending-count`
      ),
    enabled: Boolean(caseId),
    staleTime: 30_000,
  })
}
